/**
 * Determines if the current environment is staging or production
 * @returns {boolean} true if staging, false if production
 */
export const isStaging = () => {
  const hostname =
    (typeof window !== "undefined" ? window.location.hostname : undefined);

  if (!hostname) {
    // Default to staging, as we're likely running locally
    //  or in a test environment
    return true; 
  }

  // Production: beta.mattoboard.com, mattoboard.com
  if (hostname === 'beta.mattoboard.com' || hostname === 'mattoboard.com') {
    return false;
  }

  // Staging: localhost, *.web.app (preview), daily.mattoboard.com, etc.
  return true;
};

// Local dev servers and automated browsers (Playwright etc.) stay out of Sentry:
// their runs flooded staging (MATTOBOARD-6NT) and were never an early warning.
const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "[::1]"];

export const shouldReportToSentry = (
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
  webdriver = typeof navigator !== "undefined" && navigator.webdriver === true,
) => !webdriver && !LOCAL_HOSTNAMES.includes(hostname);

